import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/function';
import { getEq as RgetEq } from 'fp-ts/Record';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const eqStrMapInterpreter = memo(() => ({
    _F: EqURI,
    strMap: (getCodomain, config) => env => pipe(getCodomain(env).eq, eq => new EqType(eqApplyConfig(config)(RgetEq(eq), env, { eq }))),
    record: (getDomain, getCodomain, config) => env => 
    // domain is always comparable (this is handled by record Eq)
    ((domainEq, codomainEq) => new EqType(eqApplyConfig(config)(RgetEq(codomainEq), env, { domainEq, codomainEq })))(getDomain(env).eq, getCodomain(env).eq)
}));
